export const removeHtmlTags = (value: string, replace: string) => {
    const isEmpty = /&nbsp;|&amp;/.test(value);
    const isTag = /<\/?[^>]+(>|$)/.test(value);
    const isCrlf = /\r\n|\n/.test(value);

    const emptyFilter = isEmpty ? value.replace(/&nbsp;|&amp;/g, "") : value;
    const tagFilter = isTag ? emptyFilter.replace(/<\/?[^>]+(>|$)/g, replace) : emptyFilter;
    const crlfFilter = isCrlf ? tagFilter.replace(/\r\n|\n/g, replace) : tagFilter;
    const cleanText = crlfFilter.includes("<br>") ? crlfFilter.split("<br>") : crlfFilter;

    return { cleanText };
};
